export enum AnswerType
{
    TEXTBOX = 1,
    CHECKBOX = 2,
    SELECT = 3
}